import React from 'react';
import './contactus.css';
import logo from '../assets/Logo.png';
import email from '../assets/email-icon.png';
import phone from '../assets/phone-icon.png';

function Contact() {
  return (
    <div className="contact-page">
      <img src={logo} alt="Akhila Kerala Balajanasakhyam Logo" className="contact-logo" />

      {/* About Us Section */}
     
      <h1>CONTACT US</h1>

      <div className="contact-container">
        <h2>Get in Touch</h2>

        <div className="contact-item">
          <img src={email} alt="Email" className="contact-icon" />
          <a href="mailto:balajanasakhyam@gmail.com"><strong>balajanasakhyam@gmail.com</strong></a>
        </div>

        <div className="contact-item">
          <img src={phone} alt="Phone" className="contact-icon" />
          <p><strong>+91 98953 99491</strong></p>
        </div>

        {/* Branch Contacts in Columns */}
        <div className="branch-contacts-container">
          <div className="branch">
            <h4>Kottayam</h4>
            <p>0481 2563646, 9895395084, <br />9895395085, 9895395086</p>
          </div>
          <div className="branch">
            <h4>Thiruvananthapuram</h4>
            <p>0471 2328198, <br />98953 99733</p>
          </div>
          <div className="branch">
            <h4>Kozhikode</h4>
            <p>0495 2766305,<br /> 9895395053, <br />9895397561</p>
          </div>
          <div className="branch">
            <h4>Kochi</h4>
            <p>0484 4447888, <br />98995395005,<br /> 9895395006</p>
          </div>
          <div className="branch">
            <h4>Palakkad</h4>
            <p>0491 2538807,<br /> 9895395191</p>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Contact;
